import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const COMPANY_NAME = 'EVIMO';

export function AppSiteFooter() {
  const { t } = useTranslation('common');

  return (
    <footer className="app-site-footer" role="contentinfo">
      <Text type="secondary" className="app-site-footer__text">
        {t('footer.copyright', {
          year: new Date().getFullYear(),
          company: COMPANY_NAME,
        })}
      </Text>
    </footer>
  );
}
